export default {
  info: {
    member: {
      CustomerChoice: '会员选择',
      CustomerName: '会员名称',
      CustomerType: '会员类型',
      ContactTel: '联系电话',
      ComeFrom: '来源',
      FromWeb: '网站注册',
      FromAdmin: '管理员新增',
      Member: '直接会员',
      Agent: '所属代理商',
      Designer: '设计师',
      AgentName: '代理商名称',
      SubordinateSalesman: '所属业务员',
      SubordinateRegion: '所属区域',
      Region: '所属区域',
      RegionChoice: '区域选择',
      Salesman: '业务员',
      MemberName: '会员名称',
      AgentChoice: '代理商选择',
      AgentCode: '代理商编号',
      AgentID: '代理商ID',
      AccountName: '打款户名',
      AccountBank: '开户银行',
      AccountNo: '打款银行账号',
      Advance: '期初应付款',
      OrderDiscount: '折扣',
      Due: '应收款',
      LevelName: '级别名称',
      InitBalance: '期初余额',
      CreditLine: '信用额度',
      CautionMoney: '保证金',
      AnnualMission: '年度任务',
      PriceLevel: '价格级别',
      ContactUs: '联系我们',
      DeliveryMode: '送货方式',
      FrequentlyQuestions: '常见问题解决',
      LegalDeclarations: '法律声明',
      PrivacyClauses: '隐私条款',
      TermsConditions: '条款与条项',
      JoinUs: '加入我们',
      Title: '标题',
      Category: '类别',
      SimpleDscription: '简要描叙',
      ProductCode: '产品编号',
      CategoryName: '类别名称',
      ProductName: '产品名称',
      PicUrl: '图片',
      JobName: '岗位名称',
      WorkingPlace: '上班地点',
      JobDescription: '岗位描叙',
      TipsTheme: '提示主题',
      Tips: '提示内容',
      Status: '状态',

      // 文件上传
      DocumentUpload: '证件上传',
      UploadData: '上传资料',
      FileName: '文件名',
      FileSize: '文件大小',
      UploadTime: '上传时间',
      // 发布内容
      Published: '已发布',
      Unpublished: '未发布'

    },
    memberTag: { // 会员标签
      tagName: '标签名称',
      tagDescription: '标签描述',
      addMemberTag: '新增会员标签',
      editMemberTag: '编辑会员标签',
      memberCount: '会员数',
      ChooseLabel: '选择标签',
      EditLabel: '修改标签',
      addLabel: '加标签'
    },
    memberService: { // 服务会员
      friendStatus: '好友状态',
      weChatMobile: '微信号码',
      serviceTutor: '服务导师',
      addServiceTutor: '添加服务导师',
      babyBirthday: '宝宝生日',
      babySex: '宝宝性别',
      addFriends: '添加好友',
      Added: '已添加',
      notAdded: '未添加'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/mmc/member.js